"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TaskPage = exports.TaskColumn = exports.TaskLayout = void 0;
const styled_1 = __importDefault(require("@emotion/styled"));
const React = __importStar(require("react"));
const theme_1 = __importDefault(require("../../components/styles/theme"));
const __1 = require("../../..");
const viewstate_1 = require("../../../entities/viewstate");
const types_1 = require("../../../types");
const capability_1 = require("../../../util/capability");
const Heading_1 = require("../../components/heading/Heading");
const TaskNavigator_1 = require("../../components/task-nav/TaskNavigator");
const merlin_hooks_1 = require("@travelnest/merlin-hooks");
const MaxWidthWrapper_1 = require("../../components/max-width/MaxWidthWrapper");
const Spacer_1 = require("../../components/spacer/Spacer");
const BasePage_1 = require("./BasePage");
const ContentPage_1 = require("./ContentPage");
;
exports.TaskLayout = styled_1.default.div `
	@media only screen and (min-width: 760px) {
		${(props) => props.width ? `width: ${props.width}%;` : ''}
		display: flex;
		flex-wrap: wrap;
	}
`;
exports.TaskColumn = styled_1.default.div `
	@media only screen and (min-width: 760px) {
		${(props) => !!props.width ? `
			flex-basis: calc(${props.width}% - calc(${theme_1.default.layout.spacing.standard} / ${Math.floor(100 / props.width)}));

			margin-left: 0;
			margin-right: ${theme_1.default.layout.spacing.smaller};

			&:nth-of-type(${Math.floor(100 / props.width)}n) {
				margin-right: 0;
				margin-left: ${theme_1.default.layout.spacing.smaller};
			}
			` : 'width: 100%;'}
	}
`;
const TaskPage = (props) => {
    const { children, task, property, viewState } = props;
    const { capabilities } = React.useContext(__1.AppContext);
    const loader = React.createElement(Heading_1.Heading, { "data-testid": "task-loader" }, "Loading ...");
    const contentDiv = React.useRef(null);
    const [contentRightEdge, setContentRightEdge] = React.useState(null);
    const handleResize = (0, merlin_hooks_1.useDebouncedCallback)(() => {
        if (contentDiv.current) {
            setContentRightEdge(contentDiv.current.getBoundingClientRect().right);
        }
    }, 250);
    React.useEffect(() => {
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    });
    // For initial render, to place the TaskNavigator
    React.useLayoutEffect(() => {
        if (contentDiv.current) {
            setContentRightEdge(contentDiv.current.getBoundingClientRect().right);
        }
    }, [contentDiv]);
    const loading = viewState && viewState === viewstate_1.ViewState.LOADING;
    const showTaskNavigator = !loading && !(0, capability_1.hasCapability)(capabilities, types_1.DashboardCapabilities.DisableTaskNavigator);
    return (React.createElement(BasePage_1.BasePage, { header: React.createElement(React.Fragment, null) },
        React.createElement(ContentPage_1.PageWrapper, null,
            React.createElement(MaxWidthWrapper_1.MaxWidthWrapper, { ref: contentDiv },
                React.createElement(Spacer_1.Spacer, { spacing: "large" }),
                loading ? loader : children,
                showTaskNavigator && React.createElement(TaskNavigator_1.TaskNavigator, Object.assign({ task: task, property: property }, contentRightEdge ? { contentWidth: contentRightEdge } : null))))));
};
exports.TaskPage = TaskPage;
//# sourceMappingURL=TaskPage.js.map